<template>
  <div class="row">
    <Card
      v-for="card in cards"
      :key="card.id"
      :content="card"
    />
  </div>
</template>

<script>
import Card from './Card.vue'

export default {
  props: {
    cards: {
      type: Array,
      default: () => []
    }
  },

  components: {
    Card
  }
}
</script>